<template>
    <div class="modal-container cmnmodel small-modal">
        <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                
                <div class="modal-header justify-content-center border-0 pb-0 pt-3"><h5 class="modal-title">  {{header}}</h5><!--<a class="modal-close" @click="$emit('cancel')"><i class="fa fa-times"></i></a>--></div>
                <div class="modal-body text-center">
                    {{ question }}
                </div>
                <div class="modal-footer  border-0 pt-0">
                    <button class="btn btn-pill btn-gradient color-4" @click="$emit('confirm')" style="min-width:100px">{{confirm}}</button>
                    <button class="btn btn-pill btn-danger" @click="$emit('cancel','onCancel')">{{cancel}}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { defineComponent } from "vue";

    export default defineComponent({
        props: ["question", "header", "cancel", "confirm"],
        emits: ["confirm", "cancel","onCancel"],
    });

</script>

<style>
    
   
</style>